/* eslint-disable no-prototype-builtins */

import baseConfig from './baseConfig';
import D4CToolsStorage from '@components/D4CTools/D4CToolsStorage';

/**
 * This functions returns the config object combined to the D4C tools config
 */
const getMergedConfig = () => {
	return {
		...baseConfig,
		...D4CToolsStorage.getConfig(),
	};
};

export default {
	get: path => {
		path = path.split('.');
		const reducer = (o, i) =>
			o !== null && typeof o !== 'undefined' ? o[i] : o;
		// If it exists, get the global on window (for legacy)
		if (typeof window !== 'undefined' && window.hasOwnProperty(path[0])) {
			return path.reduce(reducer, window);
		}
		return path.reduce(reducer, getMergedConfig());
	},
	set: (path, value) => {
		path = path.split('.');
		const reducer = (o, i, j) => {
			if (j < path.length - 1) {
				return o[i];
			}
			o[i] = value;
			return void 0;
		};
		// If it exists, update the global on window (for legacy)
		if (typeof window !== 'undefined' && window.hasOwnProperty(path[0])) {
			path.reduce(reducer, window);
			return;
		}
		path.reduce(reducer, getMergedConfig());
	},
};
